var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 6.58333L12.8333 6.58333L12.8333 4.08333L11.1667 4.08333L11.1667 6.58333Z",
    fill: "#264F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 13.25L20.3333 13.25L20.3333 11.5833L17.8333 11.5833L17.8333 13.25Z",
    fill: "#264F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 13.25L6.16667 13.25L6.16667 11.5833L3.66667 11.5833L3.66667 13.25Z",
    fill: "#264F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58233 8.75477L8.75494 7.58217L6.98719 5.81442L5.81458 6.98702L7.58233 8.75477Z",
    fill: "#264F3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4121 8.76067L18.1799 6.99292L17.0073 5.82031L15.2395 7.58806L16.4121 8.76067Z",
    fill: "#264F3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.7333L9.5 19.9167L14.5 19.9167L14.5 15.7333C15.5083 14.9667 16.1667 13.775 16.1667 12.4167C16.1667 10.1167 14.3 8.25 12 8.25C9.7 8.25 7.83333 10.1167 7.83333 12.4167C7.83333 13.775 8.49167 14.9667 9.5 15.7333ZM12.8333 18.25L11.1667 18.25L11.1667 16.5C11.4333 16.55 11.7167 16.5833 12 16.5833C12.2833 16.5833 12.5667 16.55 12.8333 16.5L12.8333 18.25ZM12 9.91667C13.375 9.91667 14.5 11.0417 14.5 12.4167C14.5 13.7917 13.375 14.9167 12 14.9167C10.625 14.9167 9.5 13.7917 9.5 12.4167C9.5 11.0417 10.625 9.91667 12 9.91667Z",
    fill: "#264F3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.fffeb940.svg";
export { ForwardRef as ReactComponent };